export const LANGS = ["ru", "kg", "en"];

export const T = {
  ru: {
    appTitle: "Симулятор Президента",
    country: "Кыргызстан",
    tagline: "Один срок. Четыре шкалы. Тысяча способов всё испортить.",
    become: "Стать Президентом",
    leaderboard: "Рейтинг",
    personalBest: "Ваш рекорд",
    presidentsServed: "президентов отслужили",
    freshCards: "Свежие карты (AI)",
    generating: "Генерируем...",
    generated: "Добавлено новых карт:",
    genFailed: "Не удалось сгенерировать карты",
    introTitle: "Инаугурация",
    introText: "Поздравляем, вы избраны! Советники будут приходить с вопросами. Свайпайте карту влево или вправо. Каждое решение сдвигает четыре шкалы. Если любая шкала упадёт до нуля или заполнится до максимума — срок закончится досрочно.",
    termGoal: "Цель: продержаться 5 лет (30 решений).",
    startTerm: "Начать срок",
    meters: { eco: "Экономика", hap: "Народ", intl: "Дипломатия", stab: "Стабильность" },
    meterDesc: {
      eco: "Казна, бизнес, курс сома",
      hap: "Счастье и доверие граждан",
      intl: "Отношения с миром и соседями",
      stab: "Порядок, армия, контроль",
    },
    year: "Год",
    decision: "Решение",
    of: "из",
    swipeHint: "← свайп или тап →",
    termOver: "Срок завершён",
    termComplete: "Срок отработан!",
    score: "Очки",
    served: "Вы правили",
    years: "лет",
    months: "мес.",
    yourTitle: "Ваш титул",
    finalMeters: "Итоговые шкалы",
    nickname: "Ваше имя для рейтинга",
    submit: "В рейтинг",
    submitted: "Результат сохранён!",
    share: "Поделиться",
    copied: "Скопировано в буфер!",
    playAgain: "Играть снова",
    home: "На главную",
    rank: "#",
    player: "Игрок",
    title: "Титул",
    empty: "Пока пусто. Станьте первым президентом!",
    loading: "Загрузка...",
    signIn: "Войти через Google",
    signOut: "Выйти",
    signedInHint: "Результат будет привязан к вашему Google-аккаунту",
    shareText: (years, months, title, score) =>
      `Я продержался ${years} г. ${months} мес. Президентом Кыргызстана и получил титул «${title}»! Очки: ${score}. Побей мой результат 🇰🇬`,
    reasons: {
      eco_low: "Казна пуста. Страна объявила дефолт, а вы — банкрот.",
      eco_high: "Экономика перегрелась: олигархи скупили всё, включая ваш кабинет.",
      hap_low: "Народ вышел на площадь Ала-Тоо. Вы улетели ночным рейсом.",
      hap_high: "Народ любит вас так сильно, что объявил живой легендой и отправил на почётную пенсию на Иссык-Куль.",
      intl_low: "Полная изоляция. Даже соседи не берут трубку.",
      intl_high: "Вы так понравились иностранным партнёрам, что теперь они решают всё за вас.",
      stab_low: "Военные заняли Белый дом. Вы узнали об этом из новостей.",
      stab_high: "Вы установили полный контроль. Народ молчит... и уезжает.",
      survived: "Вы достойно завершили срок! Страна запомнит ваши решения.",
    },
    titles: {
      eco_low: "Банкрот", eco_high: "Слуга олигархов", hap_low: "Изгнанный", hap_high: "Живая легенда",
      intl_low: "Отшельник", intl_high: "Марионетка", stab_low: "Свергнутый", stab_high: "Железная рука",
      great: "Отец нации", good: "Любимый лидер", ok: "Крепкий хозяйственник", meh: "Забытый",
    },
  },
  kg: {
    appTitle: "Президент Симулятору",
    country: "Кыргызстан",
    tagline: "Бир мөөнөт. Төрт шкала. Баарын бузуунун миң жолу.",
    become: "Президент болуу",
    leaderboard: "Рейтинг",
    personalBest: "Сиздин рекорд",
    presidentsServed: "президент кызмат өтөдү",
    freshCards: "Жаңы карталар (AI)",
    generating: "Түзүлүп жатат...",
    generated: "Жаңы карталар кошулду:",
    genFailed: "Карталарды түзүү мүмкүн болбоду",
    introTitle: "Инаугурация",
    introText: "Куттуктайбыз, сиз шайландыңыз! Кеңешчилер суроолор менен келишет. Картаны солго же оңго сүрүңүз. Ар бир чечим төрт шкаланы өзгөртөт. Эгер кайсы бир шкала нөлгө түшсө же толуп кетсе — мөөнөт мөөнөтүнөн мурда бүтөт.",
    termGoal: "Максат: 5 жыл (30 чечим) кармануу.",
    startTerm: "Мөөнөттү баштоо",
    meters: { eco: "Экономика", hap: "Эл", intl: "Дипломатия", stab: "Туруктуулук" },
    meterDesc: {
      eco: "Казына, бизнес, сом курсу",
      hap: "Жарандардын бактысы жана ишеними",
      intl: "Дүйнө жана коңшулар менен мамиле",
      stab: "Тартип, армия, көзөмөл",
    },
    year: "Жыл",
    decision: "Чечим",
    of: "/",
    swipeHint: "← сүрүү же басуу →",
    termOver: "Мөөнөт бүттү",
    termComplete: "Мөөнөт аягына чыкты!",
    score: "Упай",
    served: "Сиз башкардыңыз",
    years: "жыл",
    months: "ай",
    yourTitle: "Сиздин титул",
    finalMeters: "Акыркы шкалалар",
    nickname: "Рейтинг үчүн атыңыз",
    submit: "Рейтингге",
    submitted: "Жыйынтык сакталды!",
    share: "Бөлүшүү",
    copied: "Көчүрүлдү!",
    playAgain: "Кайра ойноо",
    home: "Башкы бет",
    rank: "#",
    player: "Оюнчу",
    title: "Титул",
    empty: "Азырынча бош. Биринчи президент болуңуз!",
    loading: "Жүктөлүүдө...",
    signIn: "Google аркылуу кирүү",
    signOut: "Чыгуу",
    signedInHint: "Жыйынтык Google аккаунтуңузга байланат",
    shareText: (years, months, title, score) =>
      `Мен Кыргызстандын Президенти болуп ${years} жыл ${months} ай кармандым жана «${title}» титулун алдым! Упай: ${score}. Менин жыйынтыгымды жең 🇰🇬`,
    reasons: {
      eco_low: "Казына бош. Өлкө дефолт жарыялады, сиз — банкротсуз.",
      eco_high: "Экономика ысып кетти: олигархтар баарын, анын ичинде сиздин кабинетиңизди да сатып алды.",
      hap_low: "Эл Ала-Тоо аянтына чыкты. Сиз түнкү учак менен учуп кеттиңиз.",
      hap_high: "Эл сизди ушунчалык сүйгөндүктөн, тирүү легенда деп жарыялап, Ысык-Көлгө ардактуу пенсияга жөнөттү.",
      intl_low: "Толук обочолонуу. Коңшулар да телефон албай калды.",
      intl_high: "Чет элдик өнөктөштөргө ушунчалык жагып калдыңыз, эми алар баарын сиз үчүн чечет.",
      stab_low: "Аскерлер Ак үйдү ээледи. Сиз бул тууралуу жаңылыктан билдиңиз.",
      stab_high: "Сиз толук көзөмөл орноттуңуз. Эл унчукпайт... жана кетип жатат.",
      survived: "Сиз мөөнөтүңүздү татыктуу аяктадыңыз! Өлкө сиздин чечимдериңизди эстейт.",
    },
    titles: {
      eco_low: "Банкрот", eco_high: "Олигархтардын кызматчысы", hap_low: "Куулган", hap_high: "Тирүү легенда",
      intl_low: "Жалгыз", intl_high: "Марионетка", stab_low: "Кулатылган", stab_high: "Темир кол",
      great: "Улуттун атасы", good: "Сүйүктүү лидер", ok: "Бекем чарбакер", meh: "Унутулган",
    },
  },
  en: {
    appTitle: "President Simulator",
    country: "Kyrgyzstan",
    tagline: "One term. Four meters. A thousand ways to mess it up.",
    become: "Become President",
    leaderboard: "Leaderboard",
    personalBest: "Your best",
    presidentsServed: "presidents have served",
    freshCards: "Fresh cards (AI)",
    generating: "Generating...",
    generated: "New cards added:",
    genFailed: "Could not generate cards",
    introTitle: "Inauguration",
    introText: "Congratulations, you've been elected! Advisors will come with dilemmas. Swipe the card left or right. Every decision shifts four meters. If any meter hits zero or fills to the max — your term ends early.",
    termGoal: "Goal: survive 5 years (30 decisions).",
    startTerm: "Start the term",
    meters: { eco: "Economy", hap: "People", intl: "Diplomacy", stab: "Stability" },
    meterDesc: {
      eco: "Treasury, business, the som",
      hap: "Happiness and trust of citizens",
      intl: "Relations with the world and neighbours",
      stab: "Order, army, control",
    },
    year: "Year",
    decision: "Decision",
    of: "of",
    swipeHint: "← swipe or tap →",
    termOver: "Term over",
    termComplete: "Term complete!",
    score: "Score",
    served: "You ruled for",
    years: "yrs",
    months: "mo.",
    yourTitle: "Your title",
    finalMeters: "Final meters",
    nickname: "Your name for the leaderboard",
    submit: "Submit",
    submitted: "Result saved!",
    share: "Share",
    copied: "Copied to clipboard!",
    playAgain: "Play again",
    home: "Home",
    rank: "#",
    player: "Player",
    title: "Title",
    empty: "Nothing here yet. Be the first president!",
    loading: "Loading...",
    signIn: "Sign in with Google",
    signOut: "Sign out",
    signedInHint: "Your result will be linked to your Google account",
    shareText: (years, months, title, score) =>
      `I lasted ${years}y ${months}m as President of Kyrgyzstan and earned the title "${title}"! Score: ${score}. Beat me 🇰🇬`,
    reasons: {
      eco_low: "The treasury is empty. The country defaulted, and you're bankrupt.",
      eco_high: "The economy overheated: oligarchs bought everything, including your office.",
      hap_low: "The people filled Ala-Too Square. You left on a night flight.",
      hap_high: "The people love you so much they declared you a living legend and sent you to honorary retirement on Issyk-Kul.",
      intl_low: "Total isolation. Even the neighbours won't pick up.",
      intl_high: "Foreign partners liked you so much they now decide everything for you.",
      stab_low: "The military took the White House. You found out from the news.",
      stab_high: "You established total control. The people are silent... and leaving.",
      survived: "You finished your term with dignity! The country will remember your decisions.",
    },
    titles: {
      eco_low: "The Bankrupt", eco_high: "Servant of Oligarchs", hap_low: "The Exiled", hap_high: "Living Legend",
      intl_low: "The Hermit", intl_high: "The Puppet", stab_low: "The Overthrown", stab_high: "Iron Fist",
      great: "Father of the Nation", good: "Beloved Leader", ok: "Steady Manager", meh: "The Forgotten One",
    },
  },
};
